import { Injectable, Injector } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { ModuleInitializerHelper } from '../helper/module-initializer/module-initializer.class';
import { RoutePageComponent } from '../route-page/route-page.component';
import { WorkflowExternalConfigService } from '../service/workflow-external-config/workflow-external-config.service';
import { WorkflowService } from '../service/workflow/workflow.service';
import { WorkflowWidgetInitArgs } from '../widget-context.type';
import { WidgetContextDataShared } from './widget-context-data.shared';
import { WorkflowWidgetService } from './workflow-widget.service';
import { ProductsConfig } from '../class/config.type';

@Injectable({ providedIn: 'root' })
export class WorkflowWidgetConfigAndRouteService {
  constructor(private readonly workflowExternalConfigService: WorkflowExternalConfigService, private readonly injector: Injector) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public loadConfigsAddRoutes(arg: WorkflowWidgetInitArgs): Promise<any> {
    this.validateConfigArgs(arg);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise<any>((resolve, reject) => {
      WidgetContextDataShared.widgetContext.config.bundleApi = arg.bundleApi;
      WidgetContextDataShared.widgetContext.config.customConfig = arg.customConfig;
      this.workflowExternalConfigService.loadExternalConfig(arg.products, arg.configApi, arg.customConfig).then(
        () => {
          this.AddRoutes(arg.routePrefix, arg.includeRouteFlowIds);
          this.injector
            .get(WorkflowWidgetService)
            .init()
            .then(() => resolve(true));
        },
        () => {
          reject();
        }
      );
    });
  }

  /**
   *  Set WW Config Data and initlaize workflow service
   *  @param arg - arugments to Init Args Workflow Widget
   *  @param data - Products Config Data
   */
  public configData(arg: WorkflowWidgetInitArgs, data: ProductsConfig) {
    this.validateConfigArgs(arg);
    WidgetContextDataShared.widgetContext.config.bundleApi = arg.bundleApi;
    WidgetContextDataShared.widgetContext.config.customConfig = arg.customConfig;
    this.workflowExternalConfigService.addExternalConfig(data);
    this.AddRoutes(arg.routePrefix, arg.includeRouteFlowIds);
    this.injector.get(WorkflowWidgetService).init();
  }

  public AddRoutes(routePrefix: string, includeRouteFlowIds: string[]) {
    const workflowService = this.injector.get(WorkflowService);
    workflowService.routePrefix = routePrefix;

    let routesToRegister: Routes = [];
    const router = this.injector.get(Router);
    if (routePrefix) {
      routesToRegister = this.findDeepRoute(routePrefix);
    } else {
      // Register in root
      routesToRegister = router.config;
    }

    const moduleInitializer = new ModuleInitializerHelper().AddRoute(routePrefix, RoutePageComponent);
    const ngRoutes = moduleInitializer.GetNgRoutes(this.injector, { includeFlowIds: includeRouteFlowIds });

    routesToRegister.unshift(...ngRoutes);
    router.resetConfig(router.config);
  }

  // 'a/b'-> ['a', 'b']->[]
  private findDeepRoute(routePrefix: string): Routes {
    let currentRouteConfig = this.injector.get(Router).config;
    let routesToRegister;

    const routePrefixes = (routePrefix || '').trim().split('/');
    while (routePrefixes.length > 0) {
      const path = routePrefixes.shift();
      const parent = currentRouteConfig.find((c) => c.path === path);
      if (parent) {
        if (!parent.children) {
          parent.children = [];
        }
        currentRouteConfig = parent.children;
        if (routePrefixes.length === 0) {
          routesToRegister = currentRouteConfig;
        }
      }
    }

    if (!routesToRegister) {
      throw new Error(`There is no route found in router config with path ${routePrefix}`);
    }

    return routesToRegister;
  }

  private validateConfigArgs(args: WorkflowWidgetInitArgs): void {
    if (!args.configApi) {
      throw new Error('Config Api URL has not been set in WorkflowWidgetInitArgs.');
    }

    if (!args.products || !args.products.length) {
      throw new Error('Products has not been set in WorkflowWidgetInitArgs');
    }
  }
}
